import {Component} from '@angular/core';
import {RouterLink} from '@angular/router';
import {FilterConfig, GridPageComponent} from "../../../common/grid-page.component";
import {BlockedStockScoreGridViewDto} from "@services";
import {CommonModule} from "@angular/common";
import {
    DxDataGridModule,
    DxFormModule,
    DxTemplateModule
} from "devextreme-angular";
import {FilterPanelComponent} from "../../../../components/library/filter-panel/filter-panel.component";

@Component({
    selector: 'app-blocked-stock-score',
    standalone: true,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxFormModule,
        DxTemplateModule,
        FilterPanelComponent,
        RouterLink
    ],
    templateUrl: './blocked-stock-score.component.html',
    styles: [
        `.grid {
            height: calc(100vh - 150px);
        }`
    ]
})
export class BlockedStockScoreComponent extends GridPageComponent<BlockedStockScoreGridViewDto> {

    constructor() {
        super();
        this.init(BlockedStockScoreGridViewDto);
    }

    readonly blockUnitsFormat = "#,##0";
    readonly numberFormat = "#,##0.00";
    readonly percentFormat = "#0.00%";

    dataSource = this.dataSources.blockedStockScore();

    private createPercentFilter = (field: string) => (filterValue: any, selectedFilterOperation: string) => {
        if (filterValue === undefined || filterValue === null) {
            return null;
        }
        return [field, selectedFilterOperation || '>=', filterValue / 100];
    };

    blockedStockPercentFilter = this.createPercentFilter('blockedStockPercent');
    onHold30DaysPercentFilter = this.createPercentFilter('onHold30DaysPercent');
    onHold45DaysPercentFilter = this.createPercentFilter('onHold45DaysPercent');
    onHold90DaysPercentFilter = this.createPercentFilter('onHold90DaysPercent');
    onHold90PlusDaysPercentFilter = this.createPercentFilter('onHold90PlusDaysPercent');
    noRacCodingPercentFilter = this.createPercentFilter('noRacCodingPercent');
    noRacCodingUnmatchedPercentFilter = this.createPercentFilter('noRacCodingUnmatchedPercent');
    returnsPercentFilter = this.createPercentFilter('returnsPercent');
    damagePercentFilter = this.createPercentFilter('damagePercent');
    logisticalPercentFilter = this.createPercentFilter('logisticalPercent');
    agedOrNearingExpiryPercentFilter = this.createPercentFilter('agedOrNearingExpiryPercent');
    expiredPercentFilter = this.createPercentFilter('expiredPercent');
    foreignMaterialPercentFilter = this.createPercentFilter('foreignMaterialPercent');
    labellingPackagingPercentFilter = this.createPercentFilter('labellingPackagingPercent');
    infestationPercentFilter = this.createPercentFilter('infestationPercent');

    protected override exportName: string = "BlockedStockScore";

    protected override filterConfig: FilterConfig[] = [
        {field: 'created', op: '>='},
        {field: 'blockUnits', op: '>='},
        {field: 'blockedStock', op: '>='},
        {field: 'unmatchedBlockedStock', op: '>='},
        {field: 'totalBlockedStock', op: '>='},
        {field: 'sumOfUnrestrain', op: '>='},
        {field: 'sumOfQualityInspection', op: '>='},
        {field: 'sumOfRestrictedUse', op: '>='},
        {field: 'sumOfInventory', op: '>='},
        {field: 'blockedStockPercent', op: '>=', customFilter: this.blockedStockPercentFilter},
        {field: 'onHold30Days', op: '>='},
        {field: 'onHold30DaysPercent', op: '>=', customFilter: this.onHold30DaysPercentFilter},
        {field: 'onHold45Days', op: '>='},
        {field: 'onHold45DaysPercent', op: '>=', customFilter: this.onHold45DaysPercentFilter},
        {field: 'onHold90Days', op: '>='},
        {field: 'onHold90DaysPercent', op: '>=', customFilter: this.onHold90DaysPercentFilter},
        {field: 'onHold90PlusDays', op: '>='},
        {field: 'onHold90PlusDaysPercent', op: '>=', customFilter: this.onHold90PlusDaysPercentFilter},
        {field: 'noRacCoding', op: '>='},
        {field: 'noRacCodingPercent', op: '>=', customFilter: this.noRacCodingPercentFilter},
        {field: 'noRacCodingUnmatchedPercent', op: '>=', customFilter: this.noRacCodingUnmatchedPercentFilter},
        {field: 'returns', op: '>='},
        {field: 'returnsPercent', op: '>=', customFilter: this.returnsPercentFilter},
        {field: 'damage', op: '>='},
        {field: 'damagePercent', op: '>=', customFilter: this.damagePercentFilter},
        {field: 'logistical', op: '>='},
        {field: 'logisticalPercent', op: '>=', customFilter: this.logisticalPercentFilter},
        {field: 'agedOrNearingExpiry', op: '>='},
        {field: 'agedOrNearingExpiryPercent', op: '>=', customFilter: this.agedOrNearingExpiryPercentFilter},
        {field: 'expired', op: '>='},
        {field: 'expiredPercent', op: '>=', customFilter: this.expiredPercentFilter},
        {field: 'foreignMaterial', op: '>='},
        {field: 'foreignMaterialPercent', op: '>=', customFilter: this.foreignMaterialPercentFilter},
        {field: 'labellingPackaging', op: '>='},
        {field: 'labellingPackagingPercent', op: '>=', customFilter: this.labellingPackagingPercentFilter},
        {field: 'infestation', op: '>='},
        {field: 'infestationPercent', op: '>=', customFilter: this.infestationPercentFilter},
    ];
}
